export function OutlineParkingIcon({
  width = 24,
  height = 24,
  fill = 'none',
  stroke = 'currentColor',
  strokeWidth = 2,
}: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill={fill}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10.0991 11.0972C10.0991 11.0972 14.9999 12.3212 14.9999 8.64442C14.9999 4.96763 10.0991 6.19163 10.0991 6.19163V15.9932"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12 18.998V20.9996"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M19.08 3H4.92C3.85961 3 3 3.85961 3 4.92V17.0784C3 18.1388 3.85961 18.9984 4.92 18.9984H19.08C20.1404 18.9984 21 18.1388 21 17.0784V4.92C21 3.85961 20.1404 3 19.08 3Z"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeMiterlimit="10"
      />
    </svg>
  );
}
